// Phase 123 Plan 06 Task 1 — Frontend Sentry bootstrap.
//
// MUST be the first import in main.tsx so @sentry/react can auto-instrument
// fetch/XHR/history/unhandled-rejection before the rest of the app loads.
//
// Init is DSN-gated (no-op in dev / when VITE_SENTRY_DSN is unset) so local
// dev stays quiet. Phase 71 session-replay PII masking preserved in the init
// call-site inside ./lib/sentry.
import { initSentry } from './lib/sentry';

initSentry();
